module.exports = __webpack_public_path__ + "media/images/es_419/your_approachto_mindsetting-bdbe160c8000bf6429dceb02f4e29b93.png";